<template>
  <div id="app">
    <!-- 展位 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>
<style>
</style>
